/* ==========================================================
   Aurevaa – Free coaster set on $100+ (cart progress bar + auto-add)
   - Replaces the theme's free-shipping bar (drawer + cart page) with a
     combined "free coaster set + free U.S. shipping" progress bar.
   - Adds the coaster set to the cart automatically once eligible items
     reach $100, and removes it if the cart drops below.
   - The price is zeroed by the automatic discount "Free Coaster Set (gift on $100+)".
   - While the coaster set is sold out, the bar is a plain free-shipping bar.
   ========================================================== */
(function () {
  if (window.AurevaaGift) return;

  var CFG = {
    productId: 8722794021043,
    variantId: 46139286290611,
    threshold: 10000, // cents, shop currency
    value: '$28',
    image: 'https://cdn.shopify.com/s/files/1/0704/7285/9827/files/AC-2.png?v=1790802203&width=160',
    url: '/products/aurevaa-coaster-set-of-2'
  };
  var KEY_ADDED = 'aurevaaGiftAdded';   // we auto-added it this session (so a removal = customer declined)
  var KEY_FAIL = 'aurevaaGiftFailed';   // add failed (e.g. sold out) – stop retrying

  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, pending = false, timer = null;
  var stock = null; // null = not checked yet on this page, true/false = coaster set available
  var tooEarly = false; // shopper tried to add the gift set before reaching $100

  // Is the coaster set in stock? (inventory is tracked and overselling is off,
  // so the storefront's "available" flag turns false when it sells out)
  function checkStock(force) {
    if (stock !== null && !force) return Promise.resolve(stock);
    return fetch(root + CFG.url.replace(/^\//, '') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) { stock = false; return stock; }
        var v = (p.variants || []).filter(function (x) { return x.id === CFG.variantId; })[0];
        stock = !!(v ? v.available : p.available);
        return stock;
      })
      .catch(function () { stock = false; return stock; });
  }

  function rate() {
    var r = window.Shopify && Shopify.currency && Number(Shopify.currency.rate);
    return r || 1;
  }

  function money(cents) {
    var fmt = (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '${{amount}}';
    var fixed = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key.indexOf('comma') > -1) return fixed.replace('.', ',');
      return fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }

  function analyse(cart, inStock) {
    var eligible = 0, giftQty = 0, autoLine = null, giftLines = [], giftFinal = 0;
    cart.items.forEach(function (it) {
      if (it.product_id === CFG.productId) {
        giftQty += it.quantity;
        giftLines.push({ key: it.key, qty: it.quantity, auto: !!(it.properties && it.properties._aurevaa_gift) });
        giftFinal += it.final_line_price;
        if (it.properties && it.properties._aurevaa_gift) autoLine = { key: it.key, qty: it.quantity };
      } else {
        eligible += it.original_line_price;
      }
    });
    var threshold = Math.round(CFG.threshold * rate());
    return {
      inStock: inStock,
      eligible: eligible,
      giftQty: giftQty,
      giftLines: giftLines,
      autoLine: autoLine || (giftLines[0] ? { key: giftLines[0].key, qty: giftLines[0].qty } : null),
      threshold: threshold,
      reached: eligible >= threshold,
      remaining: Math.max(threshold - eligible, 0),
      // free shipping is judged by Shopify on the subtotal AFTER discounts (15% bundle, codes)
      shipOk: (cart.total_price - giftFinal) >= threshold,
      shipRemaining: Math.max(threshold - (cart.total_price - giftFinal), 0)
    };
  }

  function markup(s) {
    var pct = Math.min(100, Math.round(s.eligible * 100 / s.threshold));
    var msg, action = '';
    if (!s.inStock) {
      // coaster set sold out: the bar goes back to a plain free-shipping bar
      var shipPct = Math.min(100, Math.round((s.threshold - s.shipRemaining) * 100 / s.threshold));
      msg = s.shipOk ? '<strong>You’ve unlocked free U.S. shipping.</strong>' :
        'You’re <strong>' + money(s.shipRemaining) + '</strong> away from <strong>free U.S. shipping</strong>';
      return '<div class="aur-gift aur-gift--ship' + (s.shipOk ? ' is-unlocked' : '') + '">' +
        '<div class="aur-gift__body">' +
          '<p class="aur-gift__msg">' + msg + '</p>' +
          '<span class="aur-gift__track" role="progressbar" aria-label="Progress to free U.S. shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + shipPct + '"><span style="width:' + shipPct + '%"></span></span>' +
        '</div></div>' +
        '<span data-js-free-shipping-text hidden></span><span data-js-free-shipping-slider hidden></span>';
    }
    if (!s.reached && tooEarly) {
      msg = 'Our coaster set is a <strong>free gift</strong> with orders of ' + money(s.threshold) + ' or more. Add <strong>' + money(s.remaining) + '</strong> more and we’ll add it for you.';
    } else if (!s.reached) {
      msg = 'You’re <strong>' + money(s.remaining) + '</strong> away from a <strong>free coaster set</strong> + free U.S. shipping';
    } else if (s.giftQty > 0) {
      msg = '<strong>Unlocked!</strong> Your free coaster set (' + CFG.value + ' value) is in your bag' +
        (s.shipOk ? ', and U.S. shipping is on us.' : '. Add <strong>' + money(s.shipRemaining) + '</strong> more for free U.S. shipping.');
    } else if (store.get(KEY_FAIL)) {
      msg = s.shipOk ? '<strong>You’ve unlocked free U.S. shipping.</strong>' : 'Add <strong>' + money(s.shipRemaining) + '</strong> more for free U.S. shipping.';
    } else {
      msg = '<strong>You’ve unlocked a free coaster set</strong>' + (s.shipOk ? ' + free U.S. shipping.' : '. Add <strong>' + money(s.shipRemaining) + '</strong> more for free U.S. shipping.');
      action = '<button type="button" class="aur-gift__add" data-aur-gift-add>Add my free coasters</button>';
    }
    return '<div class="aur-gift' + (s.reached ? ' is-unlocked' : '') + '">' +
      '<a class="aur-gift__img" href="' + root.replace(/\/$/, '') + CFG.url + '" tabindex="-1" aria-hidden="true"><img src="' + CFG.image + '" alt="" width="48" height="48" loading="lazy"></a>' +
      '<div class="aur-gift__body">' +
        '<p class="aur-gift__msg">' + msg + '</p>' +
        '<span class="aur-gift__track" role="progressbar" aria-label="Progress to a free coaster set" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></span>' +
        action +
      '</div></div>' +
      // stubs the theme's own shipping-notice script expects (prevents a console error if it upgrades after us)
      '<span data-js-free-shipping-text hidden></span><span data-js-free-shipping-slider hidden></span>';
  }

  function paint(s) {
    document.querySelectorAll('shipping-notice').forEach(function (el) {
      el.setAttribute('data-aur-gift', '1');
      el.innerHTML = markup(s);
      var btn = el.querySelector('[data-aur-gift-add]');
      if (btn) btn.addEventListener('click', function () {
        store.del(KEY_FAIL);
        btn.disabled = true;
        addGift();
      });
    });
    tidyLines(s);
  }

  // Hide "$0.00" discount pills the free-gift discount leaves on qualifying items,
  // and lock the quantity on the auto-added gift line (it stays removable).
  function tidyLines(s) {
    document.querySelectorAll('[data-js-cart-item] .pill').forEach(function (pill) {
      if (/\(-\D*0[.,]00\D*\)/.test(pill.textContent.replace(/\s+/g, ' '))) {
        pill.style.display = 'none';
      }
    });
    if (s.autoLine) {
      document.querySelectorAll('[data-js-cart-item]').forEach(function (row) {
        if (row.getAttribute('data-id') !== s.autoLine.key || row.classList.contains('aur-gift-line')) return;
        row.classList.add('aur-gift-line');
        var anchor = row.querySelector('.cart-item__title-row, .cart-item__title');
        if (anchor) {
          var tag = document.createElement('span');
          tag.className = 'aur-gift-tag';
          tag.textContent = 'Complimentary gift';
          anchor.insertAdjacentElement('afterend', tag);
        }
      });
    }
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refresh() {
    if (typeof window.refreshCart === 'function' && document.getElementById('AjaxCartForm')) {
      window.refreshCart(false); // re-renders drawer / cart page; our observer repaints the bar
    } else {
      schedule();
    }
  }

  function addGift() {
    return post('cart/add.js', { items: [{ id: CFG.variantId, quantity: 1, properties: { _aurevaa_gift: 'Free coaster set' } }] })
      .then(function (r) {
        if (r.ok) { store.set(KEY_ADDED, '1'); } else { store.set(KEY_FAIL, '1'); return checkStock(true); }
      })
      .catch(function () { store.set(KEY_FAIL, '1'); })
      .then(refresh);
  }

  // show the cart drawer so the shopper sees the explanation (no-op on the cart page)
  function openDrawer() {
    var sb = document.getElementById('site-cart-sidebar');
    if (sb && typeof sb.show === 'function' && !document.querySelector('body.template-cart')) {
      setTimeout(function () { try { sb.show(); } catch (e) {} }, 350);
    }
  }

  function removeLine(key) {
    return post('cart/change.js', { id: key, quantity: 0 }).catch(function () {}).then(refresh);
  }

  // The coaster set is free for everyone at checkout (the discount has no minimum),
  // so the cart enforces the rule: only with $100+ of other items, and only one set.
  function enforce(lines, keepOne) {
    var chain = Promise.resolve();
    lines.forEach(function (line, i) {
      var target = (keepOne && i === 0) ? 1 : 0;
      if (line.qty === target) return;
      chain = chain.then(function () {
        return post('cart/change.js', { id: line.key, quantity: target }).catch(function () {});
      });
    });
    return chain.then(refresh);
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;
    Promise.all([
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }),
      checkStock(false)
    ])
      .then(function (res) {
        var cart = res[0];
        var s = analyse(cart, res[1]);
        paint(s);
        if (!s.inStock) {
          // sold out: never auto-add, and clear any set already in the bag so checkout isn't blocked
          if (s.giftLines.length) return enforce(s.giftLines, false);
          return;
        }
        if (s.reached) tooEarly = false;
        if (s.reached && s.giftQty === 0 && !store.get(KEY_ADDED) && !store.get(KEY_FAIL)) {
          return addGift();
        }
        if (!s.reached) {
          store.del(KEY_ADDED);
          store.del(KEY_FAIL);
          if (s.giftLines.length) {
            // explain why it disappeared instead of removing it silently
            tooEarly = true;
            return enforce(s.giftLines, false).then(openDrawer);
          }
        } else if (s.giftQty > 1) {
          // keep the auto-added line first so it is the one that stays
          s.giftLines.sort(function (a, b) { return (b.auto ? 1 : 0) - (a.auto ? 1 : 0); });
          return enforce(s.giftLines, true);
        }
      })
      .catch(function (e) { console.warn('Aurevaa gift:', e); })
      .then(function () {
        busy = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 60);
  }

  function hasFreshNotice(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches('shipping-notice:not([data-aur-gift])')) return true;
    return !!(node.querySelector && node.querySelector('shipping-notice:not([data-aur-gift])'));
  }

  function start() {
    var css = document.createElement('style');
    css.textContent =
      'shipping-notice:not([data-aur-gift]){visibility:hidden}' +
      '.aur-gift{display:flex;gap:12px;align-items:center;text-align:left}' +
      '.aur-gift__img{flex:none;display:block;width:48px;height:48px;border-radius:6px;overflow:hidden;background:#FAF7F2}' +
      '.aur-gift__img img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.aur-gift__body{flex:1;min-width:0}' +
      '.aur-gift__msg{margin:0 0 8px;font-size:14px;line-height:1.4;color:#2F3133}' +
      '.aur-gift__msg strong{font-weight:600}' +
      '.aur-gift__track{display:block;height:6px;border-radius:6px;background:#E6DFD5;overflow:hidden}' +
      '.aur-gift__track>span{display:block;height:100%;border-radius:6px;background:#6CA6A6;transition:width .4s ease}' +
      '.aur-gift.is-unlocked .aur-gift__track>span{background:#3F7A7A}' +
      '.aur-gift__add{margin-top:10px;padding:7px 14px;border:1px solid #3F7A7A;border-radius:30px;background:#fff;color:#3F7A7A;font-size:12px;letter-spacing:.04em;cursor:pointer;transition:background .2s,color .2s}' +
      '.aur-gift__add:hover{background:#3F7A7A;color:#fff}' +
      '.aur-gift__add[disabled]{opacity:.6;cursor:default}' +
      '.aur-gift-line .quantity-selector-holder{display:none !important}' +
      '.aur-gift-tag{display:block;margin:4px 0 2px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#3F7A7A}' +
      // cart drawer: keep notes/discounts right under the items instead of pinned to the bottom (no empty gap)
      '#site-cart-sidebar .sidebar__body--flex{justify-content:flex-start !important}';
    // theme previews only: leave room so Shopify's preview bar doesn't cover the Checkout button
    if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') {
      css.textContent += '#site-cart-sidebar .sidebar__footer{padding-bottom:76px !important}';
    }
    document.head.appendChild(css);

    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (meta && Number(meta.id) === CFG.productId) {
      css.textContent += 'main product-form.product-form,main .product-form-installment,main .shopify-payment-button{display:none !important}' +
        '.aur-gift-note{margin:16px 0;padding:14px 16px;border:1px solid #E6DFD5;border-radius:8px;background:#FAF7F2;color:#2F3133;font-size:15px;line-height:1.5}' +
        '.aur-gift-note strong{color:#3F7A7A}';
      var form = document.querySelector('main product-form.product-form');
      if (form) {
        var note = document.createElement('p');
        note.className = 'aur-gift-note';
        note.innerHTML = '<strong>Our gift to you.</strong> This coaster set is complimentary with orders of ' + money(Math.round(CFG.threshold * rate())) + ' or more and is added to your bag automatically.';
        form.insertAdjacentElement('beforebegin', note);
        checkStock(false).then(function (ok) {
          if (!ok) note.innerHTML = '<strong>Our gift to you.</strong> This complimentary coaster set is out of stock right now. It will be back soon.';
        });
      }
    }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasFreshNotice(added[j])) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    schedule();
  }

  window.AurevaaGift = { sync: schedule, config: CFG };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
